import { render, staticRenderFns } from "./profileGenerateKyc.vue?vue&type=template&id=acc456a8&scoped=true"
import script from "./profileGenerateKyc.vue?vue&type=script&lang=js"
export * from "./profileGenerateKyc.vue?vue&type=script&lang=js"
import style0 from "./profileGenerateKyc.vue?vue&type=style&index=0&id=acc456a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acc456a8",
  null
  
)

export default component.exports